import { AdditionalDemand, CreateSubmissionDto, IChangeSubmissionStatusDto } from '@app-types';
import axios from './axios';

const createSubmission = async (data: CreateSubmissionDto) => axios.post('/submissions', data);

const getCurrentSubmission = () => axios.get('/submissions/current/my');

// todo: add types
const calculateAllowance = (data: any) => axios.post('/submissions/expected-allowance', data);

const sendRequestedDocuments = async ({ id, data }: { id: string | undefined; data: AdditionalDemand[] }) =>
  axios.patch(`/submissions/${id}/send-requested-documents`, data);

const changeSubmissionStatusByCustomer = async ({
  id,
  data,
}: {
  id: string | undefined;
  data: IChangeSubmissionStatusDto;
}) => {
  const response = await axios.patch(`/submissions/${id}/submission-status`, data);

  return response.data;
};

export default {
  createSubmission,
  calculateAllowance,
  getCurrentSubmission,
  sendRequestedDocuments,
  changeSubmissionStatusByCustomer,
};
